import React, {Component} from 'react'
import {connect} from 'react-redux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import request from 'superagent'
import util from '../../helper/util'
import apis from '../../helper/api'

let denom_default = "../../swipe/assets/app/media/img/products/denom-default.jpg"
let photo_default = "../../swipe/assets/app/media/img/users/default.jpg"

class ModalBonus extends Component {

    constructor(props) {
        super(props)
        this.state = {
            data_bonus: [],
            data_simulasi: [],
            data_downline: [],
            bonus_used: "",
            sim_nominal: 2000,
            sim_nominal: 2000,
            simulate_downline_selected: "",
            flag_simulate_process: false
        }
        this.on_downline_clicked = this.on_downline_clicked.bind(this)
    }

    componentDidMount() {
        let self = this
        this.get_bonus_setting()
        this.get_master_downline()
    }

    get_simulation() {
        let body = {
            "session_id" : this.props.session,
            "nominal" : this.state.sim_nominal
        }
        let self = this
        let url = apis.simulasi_bonus + this.props.data.product_id
        if (self.state.simulate_downline_selected !== "") {
            url = apis.simulasi_bonus_downline.replace('{master_id}', self.state.simulate_downline_selected).replace('{product_id}', this.props.data.product_id)
        }
        if (this.props.data.product_code !== -1) {
            url = url + "/" + this.props.data.product_code
        }
        self.setState({data_simulasi: [], flag_simulate_process: true})
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_simulation", err)
                } else {
                    util.log("get_simulation", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                self.setState({data_simulasi: {data: payload.results.list, euf: util.rupiah_format(payload.results.info.trx_price_fee_end_user), price: util.rupiah_format(payload.results.info.trx_price_total), fee_type: payload.results.info.trx_price_fee_type, next: payload.results.next_page}, sim_nominal: payload.results.info.trx_price_nominal})
                            }
                        }
                    }
                }
                self.setState({flag_simulate_process: false})
            })
    }

    get_bonus_setting() {
    	if (this.props.data.bonus_url) {
    		let body = {
            "session_id" : this.props.session
        }
        let self = this
        request.post(this.props.data.bonus_url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("get_bonus_setting", err)
                } else {
                    util.log("get_bonus_setting", res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                        	if (payload.results) {
                                let used = null
                                payload.results.list.map(function(item, i) {
                                    if (item.is_used && used === null) {
                                        used = item
                                    }
                                    if (item.is_used && (used.priority > item.priority)) {
                                        used = item
                                    }
                                })
                                self.setState({data_bonus: {data: payload.results.list}, bonus_used: used})
                            }
                        } else {

                        }
                    }
                }
            })
    	}
    }

    get_master_downline() {
        let body = {
            "session_id" : this.props.session
        }
        let self = this
        request.post(apis.list_downline)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log(err)
                } else {
                    util.log(res);
                    if (res.statusCode == 200) {
                        let payload = res.body
                        util.log(payload)
                        if (payload.status == "OK") {
                            self.setState({data_downline: {data: payload.results.list, 
                                next: payload.results.next_page}})
                        }
                    }
                }
            })
    }

    detil_downline(e, index, master_id, master_name, master_url) {
        let self = this
        util.log("detil_downline", index, master_id, master_name, master_url, e)
        let downline = this.state.data_downline.data
        let master = downline[index]
        master.downline_btn_disable = true
        let title = {title: "Downline " + master_name}
        let pos = index + 1
        let coll = util.list_add_after(downline, pos, title)
        
        const target = e.target
        target.disabled = true
        target.classList.add('m-loader', 'm-loader--light', 'm-loader--right')

        let body = {
            "session_id" : this.props.session
        }
        let url = master_url
        request.post(url)
            .set("Content-Type", "application/json")
            .send(body)
            .end(function(err, res) {
                if (err || !res.ok) {
                    util.log("detil_downline", err)
                } else {
                    util.log("detil_downline", res)
                    if (res.statusCode == 200) {
                        let payload = res.body
                        if (payload.status == "OK") {
                            if (payload.results) {
                                payload.results.list.map(function(item,i) {
                                    pos = pos + 1
                                    item.show_border_left = true
                                    coll = util.list_add_after(coll, pos, item)
                                })
                            }
                            util.log("detil_downline", coll)
                            self.setState({data_downline: {data: coll}})
                        }
                    }
                }
            })
    }

    on_downline_clicked(e, downline) {
        util.log(e, downline)
        if (downline !== "") {
            this.setState({simulate_downline_selected: downline.item_id})
        } else {
            this.setState({simulate_downline_selected: ""})
        }
    }

    render() {
        let self = this
    	let data = this.props.data
        let bonus_used = this.state.bonus_used

        const DownlineItemView = (props) => 
            <div className="m-widget4__item" style={self.state.simulate_downline_selected === props.data.item_id ? {backgroundColor:'gainsboro',borderRadius:'5px',padding:'8px',cursor:'pointer'} : props.data.show_border_left ? {borderLeft: '2px solid cadetblue',padding:'8px 8px 8px 10px',cursor:'pointer'} : {padding:'8px',cursor:'pointer'}} onClick={(e) => self.on_downline_clicked(this, props.data)}>
                <div className="m-widget4__img m-widget4__img--pic">
                    <img src={props.data.photo_filename !== null && props.data.photo_filename.length !== 0 ? props.data.photo_filename : photo_default} style={{height: 25+'px',width: 25+'px'}}/>
                </div>
                <div className="m-widget4__info">
                    <span className="m-widget4__title">
                        {props.data.fullname}
                    </span>
                </div>
                <div className="m-widget4__ext" style={{display: 'flex'}}>
                    {props.data.next_downline && props.data.next_downline !== null ? <button disabled={props.data.downline_btn_disable ? true:false} className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary" onClick={(e) => self.detil_downline(e,props.pos, props.data.item_id, props.data.fullname, props.data.next_downline.url)} style={{fontSize:'smaller',
    padding:'4px 10px'}}>
                        Downline
                    </button> : ''}
                </div>
            </div>

        const DownlineLabelView = (props) => 
            <div className="m-widget4__item" style={{width: '100%',borderLeft: '2px solid cadetblue',paddingLeft: '15px'}}>
                <div className="m-widget4__info" style={{padding:'0'}}>
                    <span className="m-widget4__title" style={{fontStyle:'italic'}}>{props.data.title}</span>
                </div>
            </div>

        let simulate_label_style = {fontWeight:'normal', textAlign: 'left',color: '#575962'}

    	return (
	    	<Modal className="modal" open={true} center onClose={data.close} showCloseIcon={true} closeOnOverlayClick={false}>
	            <div className="modal-dialog modal-lg" role="document" style={{marginTop: 0+'px',marginBottom: 0+'px',width: '500px',minHeight:'600px'}}>
	                <div className="modal-content" style={{border:"white"}}>
	                    <div className="modal-header">
	                        <h5 className="modal-title">
	                            SETTING BONUS & SIMULASI PEMBAGIAN {data.product_name}
	                        </h5>
	                    </div>
	                    <div className="modal-body" style={{padding:'15px 0'}}>
	                        <div className="row">
	                        	<div className="col-lg-12">
			                        <div className="m-portlet__body">

                                        <div className="m-widget4">
                                            <label style={{fontWeight:600,fontSize:15+'px',color:'#575962',paddingLeft: '1.2rem',paddingRight:'1.2rem',marginBottom: 0}}>Setting untuk Produk ini:</label>
                                            {this.state.bonus_used.length !== 0 ?
                                                <div className="m-widget4__item" style={{paddingTop:0}}>
                                                    <div className="m-widget4__info">
                                                        <span className="m-widget4__title" style={{fontWeight:'normal'}}>
                                                            {bonus_used.description}
                                                        </span>
                                                        <br/>
                                                        <div className="m-widget4__sub">
                                                            <span>Priority: {bonus_used.priority}</span>
                                                            <br/>
                                                            <span className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px'}}>{bonus_used.bonus_type === 'PERCENTAGE' ? bonus_used.bonus_value + "%" : "Rp." + util.rupiah_format(bonus_used.bonus_value)}
                                                            </span>
                                                            <span className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px',marginLeft:'5px'}}>
                                                                    {bonus_used.bonus_type}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            : ''}
                                        </div>

                                        <div className="m-widget4" style={{paddingLeft:'1.2rem',paddingRight:'1.2rem'}}>
                                            <label style={{fontWeight: 600,fontSize: 15+'px',color: '#575962'}}>Simulasi Pembagian Bonus</label>
                                            
                                            <div className="m-form__section m-form__section--first">
                                                <div className="m-form__group row" style={{marginBottom: '10px'}}>
                                                    <label className="col-lg-2" style={{fontWeight: 600, textAlign: 'left',color: '#575962',margin: 'auto'}}>
                                                        Nominal:
                                                    </label>
                                                    <div className="col-lg-10">
                                                        <input onChange={(e) => this.setState({sim_nominal: e.target.value})}
                                                            type="text"
                                                            className="form-control m-input"
                                                            name="nominal"
                                                            value={this.state.sim_nominal}
                                                            style={{padding: '5px'}}/>
                                                    </div>
                                                </div>
                                            </div>

                                            <label className="" style={{fontWeight:600,textAlign:'left',color:'#575962',margin:'auto'}}>
                                                Simulasikan pada Agen:
                                            </label>

                                            <div style={{margin:'10px 0'}}>
                                                <div className="m-widget4__item" style={self.state.simulate_downline_selected === "" ? {backgroundColor:'gainsboro',borderRadius:'5px',padding:'8px',cursor:'pointer'} : {padding:'8px',cursor:'pointer'}} onClick={(e) => self.on_downline_clicked(this, "")}>
                                                <div className="m-widget4__img m-widget4__img--pic">
                                                    <img src={photo_default} style={{height: 25+'px',width: 25+'px'}}/>
                                                </div>
                                                <div className="m-widget4__info">
                                                    <span className="m-widget4__title">
                                                        Agen Saya
                                                    </span>
                                                </div>
                                            </div>
                                                {this.state.data_downline.length !== 0 && this.state.data_downline.data !== undefined ?
                                                this.state.data_downline.data.map(function(item, key) {
                                                    return (item.item_id ? <DownlineItemView data={item} pos={key} key={key}/> : <DownlineLabelView data={item} pos={key} key={key}/>)
                                                })
                                                :''}
                                            </div>

                                            <div className="m-form__group row" style={{margin: '10px 0 20px 0'}}>
                                                <div className="">
                                                    <button onClick={(e) => self.get_simulation()} className={self.state.flag_simulate_process ? "btn btn-secondary m-btn m-btn--custom m-btn--bolder m-loader m-loader--primary m-loader--right" : "btn btn-secondary m-btn m-btn--custom m-btn--bolder"} style={{marginLeft: '0px',fontSize: 'small',paddingTop:'6px',paddingBottom:'6px'}}>Submit Simulasi</button>
                                                </div>
                                            </div>

                                            {this.state.data_simulasi.length !== 0 && this.state.data_simulasi.data !== undefined ?
                                            <div className="m-form__group">
                                                <span style={{fontWeight:'600',textAlign:'left',color: '#575962'}}>
                                                    HASIL SIMULASI PEMBAGIAN BONUS
                                                </span><br/>
                                                <span style={simulate_label_style}>
                                                    Nominal Harga : Rp.{util.rupiah_format(this.state.sim_nominal)}
                                                </span><br/>
                                                <span style={simulate_label_style}>
                                                    End User Fee (EUF) : Rp.{this.state.data_simulasi.euf} ({this.state.data_simulasi.fee_type})
                                                </span><br/>
                                                <span style={simulate_label_style}>
                                                    Total Harga Produk : Rp.{this.state.data_simulasi.price}
                                                </span>
                                            </div> : ''}

                                            {this.state.data_simulasi.length !== 0 && this.state.data_simulasi.data !== undefined ?
                                                this.state.data_simulasi.data.map(function(item, key) {
                                                return (<div key={key} className="m-widget4__item" style={item.level < self.props.profile.level ? {display:'none'} : {}}>
                                                        <div className="m-widget4__img m-widget4__img--pic">
                                                            <img src={item.photo_filename.length !== 0 ? item.photo_filename : '../../swipe/assets/app/media/img/users/default.jpg'} style={{height: 55+'px',width: 55+'px'}}/>
                                                        </div>
                                                        <div className="m-widget4__info">
                                                            <span className="m-widget4__title">
                                                                {item.fullname}
                                                            </span>
                                                            <br/>
                                                            <div className="m-widget4__sub">
                                                                <span className="m-widget4__sub">Level {item.level} {item.user_type}</span>
                                                                <br/>
                                                                {item.setting.description ? <span style={{display:'none'}}>{item.setting.description}</span> : ''}
                                                                {item.setting.bonus_type ? <span className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px'}}>{item.setting.bonus_type === 'PERCENTAGE' ? item.setting.bonus_value + "%" : "Rp." + util.rupiah_format(item.setting.bonus_value)}
                                                                </span> : ''}
                                                                {item.setting.bonus_type ? <span className="m-badge m-badge--metal m-badge--wide m-badge--rounded" style={{marginTop: '5px',marginLeft:'5px'}}>
                                                                    {item.setting.bonus_type}
                                                                </span> : ''}
                                                            </div>
                                                        </div>
                                                        <div className="m-widget4__ext">
                                                            <a className="m-btn m-btn--pill m-btn--hover-brand btn btn-sm btn-secondary">
                                                                Rp. {item.trx_bonus_received}
                                                            </a>
                                                        </div>
                                                    </div>)
                                                }) : ''}
                                        </div>
			                        </div>
			                    </div>
				            </div>
	                    </div>
	                    <div className="modal-footer" style={{borderTop: 0, display:'none'}}>
	                    </div>
	                </div>
	            </div>
	        </Modal>
        )
    }
}

const mapDispatchToProps = (dispatch) => ({
})

const mapStateToProps = (state) => ({
    session : state.Session,
    profile: state.Profile
})

export default connect(mapStateToProps, mapDispatchToProps)(ModalBonus)



// WEBPACK FOOTER //
// ./src/component/form/dialog_bonus.js